import React from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { ReactComponent as PackageInCircleIcon } from "icons/package_in_circle.svg";

const NeedVerificationPanel = ({ status }) => {
  if (!["need_verification"].includes(status)) {
    return null;
  }

  return (
    <div
      className={classNames("status-panel", {
        error: true,
      })}
    >
      <div className="status-panel__info">
        <div className="info-icon">
          <PackageInCircleIcon />
        </div>
        <div className="info-text">
          <p className="title">!! PACZKI DO KONTROLI !!</p>
          <p className="desc">
            Zanieś proszę paczki z tego zamówienia do biura w celu werfyikacji
            poprawności spakowania.
          </p>
        </div>
      </div>
    </div>
  );
};

export default connect(
  ({
    pack_gdn: {
      data: { id, status, problem_station_note, gdn_lines },
    },
  }) => ({ id, status, problem_station_note, gdn_lines })
)(withRouter(NeedVerificationPanel));
